import { useState, useEffect } from "react";
import { Box, TextField, Typography, Button } from "@material-ui/core";
import Grid3x3Icon from "@mui/icons-material/Grid3x3";
import FilterXIcon from "@mui/icons-material/FilterAlt";
import CheckIcon from "@mui/icons-material/Check";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MaskAndValid from "utils/maskAndValid";
import { getPreviewColorHex } from "../utils/colorPreviewHex";

function getUrlsForVariant(fam, variant) {
  if (fam.variantImages && fam.variantImages[variant]) {
    const val = fam.variantImages[variant];
    return Array.isArray(val) ? val : val ? [val] : [];
  }
  if (fam.images && Array.isArray(fam.images)) {
    const entry = fam.images.find((i) => i.variant === variant);
    return entry?.url ? [entry.url] : [];
  }
  return [];
}

function getImageForVariant(fam, variant) {
  const urls = getUrlsForVariant(fam, variant);
  return urls.length > 0 ? urls[0] : null;
}

function GradeProductCardImage({ fam, getStatusBadge, itemsInCart, theme }) {
  const variants = fam.variants || [];
  const [activeColorIndex, setActiveColorIndex] = useState(0);
  const currentVariant = variants[activeColorIndex] || variants[0];
  const urlsForColor = getUrlsForVariant(fam, currentVariant);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    setPhotoIndex(0);
  }, [activeColorIndex, currentVariant]);

  if (variants.length === 0) {
    return (
      <Box className="product-card-ecommerce-image product-card-grade-image" style={{ position: "relative" }}>
        <Typography style={{ color: "#d1d5db", fontWeight: 700, fontSize: "1.25rem" }}>
          COLEÇÃO
        </Typography>
        <Box style={{ position: "absolute", top: 8, left: 8, display: "flex", flexDirection: "column", gap: 4 }}>
          {getStatusBadge(fam.status)}
          {fam.vitrine && (
            <Box
              style={{
                fontSize: 10,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: "rgba(255,255,255,0.9)",
                color: "#374151",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              }}
            >
              {fam.vitrine}
            </Box>
          )}
        </Box>
      </Box>
    );
  }

  const numPhotos = urlsForColor.length || 1;
  const goPrev = (e) => {
    e.stopPropagation();
    setPhotoIndex((i) => (i <= 0 ? numPhotos - 1 : i - 1));
  };
  const goNext = (e) => {
    e.stopPropagation();
    setPhotoIndex((i) => (i >= numPhotos - 1 ? 0 : i + 1));
  };

  const slides = urlsForColor.length > 0 ? urlsForColor : [null];
  const currentSlide = slides[photoIndex % slides.length];

  return (
    <Box
      className="product-card-ecommerce-image product-card-grade-image"
      style={{ position: "relative" }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box className="grade-carousel-track" style={{ width: "100%", height: "100%", overflow: "hidden", position: "relative" }}>
        <Box
          className="grade-carousel-slides"
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%",
            width: `${slides.length * 100}%`,
            position: "absolute",
            left: 0,
            top: 0,
            transform: `translateX(-${(photoIndex / slides.length) * 100}%)`,
            transition: "transform 0.3s ease-out",
          }}
        >
          {slides.map((imgUrl, idx) => (
            <Box
              key={idx}
              className="grade-carousel-slide"
              style={{
                width: `${100 / slides.length}%`,
                flex: `0 0 ${100 / slides.length}%`,
                height: "100%",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getPreviewColorHex(currentVariant, fam),
                position: "relative",
                boxSizing: "border-box",
              }}
            >
              {imgUrl ? (
                <img
                  src={imgUrl}
                  alt={currentVariant}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Typography
                  style={{
                    color: "rgba(0,0,0,0.4)",
                    fontWeight: 700,
                    fontSize: "0.875rem",
                    textAlign: "center",
                    padding: 8,
                  }}
                >
                  {currentVariant}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Box>
      {slides.length > 1 && (
        <>
          <Button
            className="grade-carousel-btn grade-carousel-btn-prev"
            onClick={goPrev}
            size="small"
            style={{ minWidth: 32, minHeight: 32, padding: 0, color: theme.primary }}
          >
            <ChevronLeftIcon style={{ fontSize: 20 }} />
          </Button>
          <Button
            className="grade-carousel-btn grade-carousel-btn-next"
            onClick={goNext}
            size="small"
            style={{ minWidth: 32, minHeight: 32, padding: 0, color: theme.primary }}
          >
            <ChevronRightIcon style={{ fontSize: 20 }} />
          </Button>
        </>
      )}
      <Box style={{ position: "absolute", top: 8, left: 8, display: "flex", flexDirection: "column", gap: 4, zIndex: 2 }}>
        {getStatusBadge(fam.status)}
        {fam.vitrine && (
          <Box
            style={{
              fontSize: 10,
              fontWeight: 600,
              padding: "2px 8px",
              borderRadius: 4,
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#374151",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            {fam.vitrine}
          </Box>
        )}
      </Box>
      {itemsInCart > 0 && (
        <Box
          style={{
            position: "absolute",
            bottom: 8,
            right: 8,
            backgroundColor: "#22c55e",
            color: "white",
            fontSize: 10,
            fontWeight: 700,
            padding: "4px 8px",
            borderRadius: 4,
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            display: "flex",
            alignItems: "center",
            gap: 4,
            zIndex: 2,
          }}
        >
          <CheckIcon style={{ fontSize: 12 }} />
          NO PEDIDO
        </Box>
      )}
      <Box className="grade-color-navigator" onClick={(e) => e.stopPropagation()}>
        {variants.map((variant, idx) => {
          const thumbUrls = getUrlsForVariant(fam, variant);
          const thumbImg = thumbUrls.length > 0 ? thumbUrls[0] : null;
          const isActive = idx === activeColorIndex;
          return (
            <Box
              key={variant}
              className={`grade-color-thumb ${isActive ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setActiveColorIndex(idx);
              }}
              style={{
                backgroundColor: getPreviewColorHex(variant, fam),
                opacity: isActive ? 1 : 0.5,
                border: isActive ? `2px solid ${theme.primary}` : "2px solid transparent",
                boxShadow: isActive ? "0 0 0 1px rgba(0,0,0,0.1)" : "none",
              }}
              title={variant}
            >
              {thumbImg ? (
                <img
                  src={thumbImg}
                  alt={variant}
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
                />
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default function ProductList({
  currentBrand,
  families,
  filteredFamilies,
  orderState,
  setOrderState,
  openGridModal,
  productSearchTerm,
  theme,
}) {
  const brandFamilies = families[currentBrand];

  const getStatusBadge = (status) => {
    return (
      <Box className={`card-status-badge status-badge status-${status}`} title={`Status: ${status}`}>
        {status}
      </Box>
    );
  };

  const filterProducts = (fam) => {
    if (!productSearchTerm) return true;
    const searchLower = productSearchTerm.toLowerCase();
    const display = (fam.productDisplayName || "").toLowerCase();
    const coll = (fam.collectionName || "").toLowerCase();
    return (
      fam.name.toLowerCase().includes(searchLower) ||
      display.includes(searchLower) ||
      coll.includes(searchLower) ||
      fam.commercialName.toLowerCase().includes(searchLower) ||
      fam.products.some(
        (p) =>
          (p.name && p.name.toLowerCase().includes(searchLower)) ||
          (p.fullName && p.fullName.toLowerCase().includes(searchLower)) ||
          (p.ref && p.ref.toLowerCase().includes(searchLower))
      )
    );
  };

  if (filteredFamilies.length === 0) {
    return (
      <Box className="empty-state" style={{ gridColumn: "1 / -1" }}>
        <FilterXIcon className="empty-icon" />
        <Typography className="empty-text">
          Nenhum produto corresponde aos filtros selecionados.
        </Typography>
      </Box>
    );
  }

  const filteredBySearch = filteredFamilies.filter((familyKey) => {
    const fam = brandFamilies[familyKey];
    return filterProducts(fam);
  });

  const gradeFamilyKeys = filteredBySearch.filter(
    (familyKey) => brandFamilies[familyKey].renderType !== "rows"
  );
  const avulsoFamilyKeys = filteredBySearch.filter(
    (familyKey) => brandFamilies[familyKey].renderType === "rows"
  );

  const avulsoCards = [];
  avulsoFamilyKeys.forEach((familyKey) => {
    const fam = brandFamilies[familyKey];
    fam.products.forEach((prod) => {
      const compoundId = `${familyKey}_${prod.id}_Único`;
      const qty = orderState[compoundId] || "";
      const finalPrice = prod.price * (1 - (prod.discount || 0) / 100);
      const hasDiscount = prod.discount > 0;
      avulsoCards.push(
            <Box
              key={`${familyKey}-${prod.id}`}
              className="product-card-ecommerce"
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = theme.primary;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e5e7eb";
              }}
            >
              <Box className="product-card-ecommerce-image">
                <Typography style={{ color: "#d1d5db", fontWeight: 700, fontSize: "1.25rem" }}>
                  AVULSO
                </Typography>
                <Box style={{ position: "absolute", top: 8, left: 8, display: "flex", flexDirection: "column", gap: 4 }}>
                  {getStatusBadge(prod.status || fam.status)}
                  {fam.vitrine && (
                    <Box
                      style={{
                        fontSize: 10,
                        fontWeight: 600,
                        padding: "2px 8px",
                        borderRadius: 4,
                        backgroundColor: "rgba(255,255,255,0.9)",
                        color: "#374151",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      }}
                    >
                      {fam.vitrine}
                    </Box>
                  )}
                </Box>
                {prod.discount > 0 && (
                  <Box
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      backgroundColor: theme.primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: 700,
                      padding: "4px 8px",
                      borderRadius: 4,
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    }}
                  >
                    -{prod.discount}%
                  </Box>
                )}
              </Box>
              <Box className="product-card-ecommerce-body">
                <Box style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 12, color: "#6b7280" }}>
                  <span>{fam.commercialName}</span>
                  <span>Ref: {prod.ref}</span>
                </Box>
                <Typography style={{ fontSize: 14, fontWeight: 700, color: "#1f2937", marginBottom: 8, lineHeight: 1.25, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {prod.name || (prod.ref ? `Produto ${prod.ref}` : "Produto")}
                </Typography>
                <Box style={{ marginTop: "auto", paddingTop: 8 }}>
                  <Box style={{ display: "flex", alignItems: "flex-end", gap: 8, marginBottom: 12 }}>
                    {hasDiscount ? (
                      <>
                        <Typography style={{ fontSize: 12, color: "#9ca3af", textDecoration: "line-through" }}>
                          R$ {MaskAndValid.maskPrice(prod.price)}
                        </Typography>
                        <Typography style={{ fontSize: 18, fontWeight: 700, color: theme.primary }}>
                          R$ {MaskAndValid.maskPrice(finalPrice)}
                        </Typography>
                      </>
                    ) : (
                      <Typography style={{ fontSize: 18, fontWeight: 700, color: theme.primary }}>
                        R$ {MaskAndValid.maskPrice(prod.price)}
                      </Typography>
                    )}
                    <Box style={{ marginLeft: "auto", textAlign: "right" }}>
                      <Typography style={{ fontSize: 10, color: "#9ca3af" }}>{prod.unit || "UN"}</Typography>
                      {prod.multiple && prod.multiple > 1 && (
                        <Typography style={{ fontSize: 9, fontWeight: 700, color: theme.primary }}>Múlt. de {prod.multiple}</Typography>
                      )}
                    </Box>
                  </Box>
                  <TextField
                    type="number"
                    placeholder="0"
                    size="small"
                    fullWidth
                    value={qty}
                    onChange={(e) => {
                      const val = e.target.value;
                      const multiple = prod.multiple || 1;
                      let intVal = parseInt(val, 10) || 0;
                      const newOrderState = { ...orderState };
                      if (intVal > 0) {
                        const remainder = intVal % multiple;
                        if (remainder !== 0) intVal = intVal + (multiple - remainder);
                        newOrderState[compoundId] = intVal;
                      } else {
                        delete newOrderState[compoundId];
                      }
                      setOrderState(newOrderState);
                    }}
                    inputProps={{
                      min: 0,
                      step: prod.multiple || 1,
                      style: { textAlign: "center", fontWeight: 700, fontSize: 14 },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          );
    });
  });

  const gradeCards = [];
  gradeFamilyKeys.forEach((familyKey) => {
    const fam = brandFamilies[familyKey];
    const itemsInCart = Object.keys(orderState).filter((k) =>
      k.startsWith(familyKey)
    ).length;
    gradeCards.push(
      <Box
        key={familyKey}
        className="product-card-ecommerce"
        onClick={() => openGridModal(familyKey)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openGridModal(familyKey);
          }
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = theme.primary;
          e.currentTarget.style.cursor = "pointer";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "#e5e7eb";
        }}
        style={{ cursor: "pointer" }}
      >
            <GradeProductCardImage
              fam={fam}
              getStatusBadge={getStatusBadge}
              itemsInCart={itemsInCart}
              theme={theme}
            />
            <Box className="product-card-ecommerce-body">
              <Typography style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                {[fam.collectionName, fam.commercialName, fam.subcategory]
                  .filter(Boolean)
                  .join(" • ")}
              </Typography>
              <Typography style={{ fontSize: 14, fontWeight: 700, color: "#1f2937", marginBottom: 16, lineHeight: 1.25 }}>
                {fam.productDisplayName || fam.name}
              </Typography>
              <Box style={{ display: "flex", alignItems: "flex-end", gap: 8, marginBottom: 12 }}>
                {(() => {
                  const prices = fam.products.map((p) =>
                    p.discount > 0
                      ? p.price * (1 - p.discount / 100)
                      : p.price
                  );
                  const minPrice = Math.min(...prices);
                  const maxPrice = Math.max(...prices);
                  const hasDiscountInFam = fam.products.some((p) => p.discount > 0);
                  const maxDisc = hasDiscountInFam
                    ? Math.max(...fam.products.map((p) => p.discount || 0))
                    : 0;
                  const numCores = fam.variants?.length ?? 0;
                  const multiples = fam.products.map((p) => p.multiple || 1);
                  const minMultiple = Math.min(...multiples);
                  const showMultiple = minMultiple > 1;
                  return (
                    <>
                      <Box style={{ flex: 1,gap: 8, minWidth: 0 }}>
                        <Typography style={{ fontSize: 16, fontWeight: 700, color: theme.primary }}>
                          R$ {MaskAndValid.maskPrice(minPrice)} - R$ {MaskAndValid.maskPrice(maxPrice)}
                        </Typography>
                        {hasDiscountInFam && maxDisc > 0 && (
                          <Typography style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", marginTop: 2 }}>
                            até {maxDisc}% de desconto
                          </Typography>
                        )}
                      </Box>
                      <Box style={{ marginLeft: "auto", textAlign: "right" }}>
                        <Typography style={{ fontSize: 10, color: "#9ca3af" }}>
                          {numCores} {numCores === 1 ? "COR" : "CORES"}
                        </Typography>
                          <Typography style={{ fontSize: 9, fontWeight: 700, color: theme.primary }}>
                            {showMultiple ? `Múlt. de ${minMultiple}` : 'UN'}
                          </Typography>
                      </Box>
                    </>
                  );
                })()}
              </Box>
              <Box style={{ marginTop: "auto" }}>
                <Button
                  fullWidth
                  className="open-grid-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    openGridModal(familyKey);
                  }}
                  style={{
                    borderColor: theme.primary,
                    color: theme.primary,
                  }}
                  startIcon={<Grid3x3Icon />}
                >
                  SELECIONAR GRADE
                </Button>
              </Box>
            </Box>
          </Box>
    );
  });

  return (
    <Box className="product-list-wrapper">
      {gradeCards.length > 0 && (
        <Box className="product-list-block">
          <Typography className="product-list-block-title">
            Coleções
          </Typography>
          <Box className="product-list-container">{gradeCards}</Box>
        </Box>
      )}
      {avulsoCards.length > 0 && (
        <Box className="product-list-block">
          <Typography className="product-list-block-title">
            Produtos Avulsos
          </Typography>
          <Box className="product-list-container">{avulsoCards}</Box>
        </Box>
      )}
      {gradeCards.length === 0 && avulsoCards.length === 0 && (
        <Box className="empty-state" style={{ gridColumn: "1 / -1" }}>
          <FilterXIcon className="empty-icon" />
          <Typography className="empty-text">
            Nenhum produto corresponde aos filtros selecionados.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
